(function() {
  'use strict';
  angular.module('benefits')
  .filter('planName', function() {
    var planNames = {
      Dental: {
        PPO: "Dental PPO",
        EPO: "Dental EPO",
        TRAD: "Dental Traditional",
        HMO: "Dental HMO",
        SCHED: "Dental Schedule"
      },
      Medical: {
        PPO: "Medical PED",
      }

    };
    return function(plan) {
      if (!plan) {
        return '';
      }
      return planNames[plan.policyType]? planNames[plan.policyType][plan.planType] : "";
    };
  });
})();
